class AccountDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#AccountDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.bindTriggers();
    this.bindShopifyAccountBridge();
  }

  bindTriggers() {
    document.querySelectorAll('[data-account-drawer-open]').forEach((trigger) => {
      if (trigger.dataset.accountDrawerBound === 'true') return;
      trigger.dataset.accountDrawerBound = 'true';
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(trigger);
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE' || event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
          this.open(trigger);
        }
      });
    });
  }

  bindShopifyAccountBridge() {
    const bridge = this.querySelector('[data-account-drawer-shopify-sign-in]');
    if (bridge) {
      bridge.addEventListener('click', () => {
        const account = document.querySelector('shopify-account.conceal-shopify-account--bridge');
        if (!account) return;
        const part = account.shadowRoot?.querySelector('[part="signed-out-avatar"]') || account;
        part.click();
        this.close();
      });
    }

    const inDrawerAccount = this.querySelector('[data-account-drawer-shopify-account]');
    if (inDrawerAccount) {
      inDrawerAccount.addEventListener('click', () => {
        // Shop auth UI opens over the page; close drawer so it isn't stuck underneath.
        setTimeout(() => this.close(), 150);
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;
    this.bindTriggers();
    setTimeout(() => this.classList.add('animate', 'active'));
    document.body.classList.add('overflow-hidden');

    this.addEventListener(
      'transitionend',
      () => {
        const focusTarget = this.querySelector('.drawer__close') || this.querySelector('.drawer__inner');
        if (typeof trapFocus === 'function' && focusTarget) {
          trapFocus(this.querySelector('.drawer__inner'), focusTarget);
        }
      },
      { once: true },
    );
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('account-drawer', AccountDrawer);
